/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import {
    sectionContainer,
    sectionHeader,
    headerContent,
    iconButton,
    sectionContent,
    collapsedContent,
    expandedContent,
} from '../styles/CollapsibleSection.styles';

const CollapsibleSection = ({ title, subtitle, children, defaultExpanded = true }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div css={sectionContainer}>
            <div css={sectionHeader} onClick={toggleExpanded}>
                <div css={headerContent}>
                    <span>{title}</span>
                    {subtitle && <span>{subtitle}</span>}
                </div>
                <button css={iconButton} onClick={toggleExpanded}>
                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                </button>
            </div>
            <div css={[sectionContent, isExpanded ? expandedContent : collapsedContent]}>{children}</div>
        </div>
    );
};

export default CollapsibleSection;
